if (!customElements.get('featured-blogs-swiper')) {
    customElements.define('featured-blogs-swiper', class FeaturedProductsSwiper extends HTMLElement {
        constructor() {
            super();
            this.swiper = null;
            this.swiperContainer = null;
            this.swiperSlides = null;
        }

        connectedCallback() {
            this.swiperContainer = this.querySelector('.swiper');
            if (!this.swiperContainer) return;
            this.initSwiper();
        }

        initSwiper() {
            this.swiper = new Swiper(this.swiperContainer, {
                slidesPerView: 3,
                spaceBetween: 24,
                navigation: {
                    nextEl: this.querySelector('.swiper-button-next'),
                    prevEl: this.querySelector('.swiper-button-prev'),
                },
                breakpoints: {
                    320: { slidesPerView: 1, spaceBetween: 10 },
                    750: { slidesPerView: 2, spaceBetween: 16 },
                    1024:{ slidesPerView: 3, spaceBetween: 24 },
                    1441: { slidesPerView: 3, spaceBetween: 24 }
                }
            });
        }
    });
}